import { inject, injectable } from 'inversify';
import Debug from 'debug';
import { QueryBadgeStatesTrackingQuery, QueryBadgeStatesTrackingQueryPayload } from '../api'
import { QueryHandler } from '@/app/tracking/common';
import { BadgeSuspendDataStateStore } from './badge-suspend-data-state-store';

const debug = Debug('query-badge-states-query-handler')

@injectable()
export class QueryBadgeStatesQueryHandler implements QueryHandler<QueryBadgeStatesTrackingQuery> {

  constructor (
    @inject(BadgeSuspendDataStateStore)
    private badgeStateStore: BadgeSuspendDataStateStore,
  ) {}
  
  public async execute(query: QueryBadgeStatesTrackingQueryPayload) {

    debug('execute', query)

    const badges = await this.badgeStateStore.query('all')
    const mapped = badges.map((x) => {
      if (x.status === 'earned') {
        return {
          ...x,
          date: new Date(x.date)
        };
      }

      return {
        ...x
      }
    })

    debug('badges', mapped)

    return {
      badges: mapped
    }
  }
}
